import {useI18n} from 'vue-i18n'
import {useLocaleProfile} from '@/composables/useLocaleProfile'

// Názvy produktů pro zákazníka. Sdílený soubor pro všechny čtyři objednávkové
// formuláře (company, readymade, seat, trade) — drž ho v nich stejný. Liší se jen
// tím, odkud se bere jazyk mutace: tenhle formulář má profily (localeProfiles.js),
// ostatní mapu IS_PRODUCT_LANGS ve store.
//
// Katalog (product.json z IS) se použije jen v mutacích s productNamesFromCatalog
// (zatím SK). Ostatní mutace mají v košíku názvy z locales a do Swiss posílají
// výchozí (český) název z IS.
//
//   productName()    katalog → locales → výchozí `name`   (košík)
//   serviceName()    locales → katalog → výchozí `name`
//   orderItemName()  katalog → výchozí `name`             (položka objednávky do Swiss)
//
// Tady zatím serviceName() nikdo nevolá; zůstává, aby šel soubor kopírovat mezi
// formuláři beze změn.
export function useProductName() {
    const {t, te} = useI18n({useScope: 'global'})
    const {profile} = useLocaleProfile()

    // Překlad z katalogu podle jazyka mutace, nebo null.
    function fromCatalog(product) {
        if (!profile.value.productNamesFromCatalog) return null;
        const isProductLang = profile.value.isProductLang;
        const translation = (product.nameTranslations || [])
            .find(tr => tr.languageId === isProductLang);
        return translation && translation.translation ? translation.translation : null;
    }

    // Kurátorovaný název z locales, nebo null.
    function fromLocales(product) {
        const key = 'productNameFallback.' + product.code;
        return te(key) ? t(key) : null;
    }

    // Katalog občas nese název s mezerou na konci ("Trade license – administrative fee ").
    // Šablony za název lepí dvojtečku, takže by se z té mezery stal bod zalomení
    // a dvojtečka by v užším sloupci odskočila na vlastní řádek.
    const normalize = (nazev) => (nazev || '').trim();

    function productName(product) {
        if (!product) return '';
        return normalize(fromCatalog(product) || fromLocales(product) || product.name);
    }

    function serviceName(product) {
        if (!product) return '';
        return normalize(fromLocales(product) || fromCatalog(product) || product.name);
    }

    function orderItemName(product) {
        if (!product) return '';
        return normalize(fromCatalog(product) || product.name);
    }

    return {productName, serviceName, orderItemName}
}
